export default {"src":"/_next/static/media/homepage_header_mountain_min.8f5005d7.svg","height":1600,"width":4096,"blurWidth":0,"blurHeight":0};